export interface AddressPlace {
  /** Населённый пункт: «станица Новотитаровская», «хутор Копанской». */
  locality?: string | null
  /** Улица или заменяющий её посёлок/квартал: «улица Ленина», «посёлок Южгипрониисельстрой». */
  street?: string | null
}

const normalize = (value: string | null | undefined): string =>
  (value ?? '')
    .toLowerCase()
    .replaceAll('ё', 'е')
    .replaceAll(/[^\da-zа-я]+/gi, ' ')
    .trim()

/**
 * Две части адреса точно РАЗНЫЕ. Пустое значение с любой стороны — это «неизвестно»,
 * а не «другое»: у сохранённых адресов старого формата компоненты часто не заполнены,
 * и считать их отличием значило бы стирать уточнения на ровном месте.
 */
const differs = (a: string | null | undefined, b: string | null | undefined): boolean => {
  const left = normalize(a)
  const right = normalize(b)
  return left !== '' && right !== '' && left !== right
}

/**
 * Один и тот же адрес с точностью до улицы и населённого пункта.
 *
 * По этому признаку решается судьба уточнений («Квартира», «Подъезд», «Этаж»,
 * «Домофон», комментарий курьеру): сменилась улица или населённый пункт — уточнения
 * относились к другому дому и должны очиститься, иначе курьер поедет в чужую квартиру.
 * Правка номера дома или опечатки в строке уточнения не трогает: стирать их на каждое
 * нажатие клавиши — только мучить клиента (решение владельца 16.09.2026).
 */
export function isSameStreetAndLocality(a: AddressPlace, b: AddressPlace): boolean {
  return !differs(a.locality, b.locality) && !differs(a.street, b.street)
}
